import { StyledDecisionFooter } from "../../styles/StyledDecision";
import { PropTypes } from "prop-types";
import { useState, useEffect } from "react";
import { DecisionSlider } from "../DecisionList/DecisionSlider";
import { StyledPageHeader } from "../../styles/StyledPage";

export default function DecisionFooter({ id, edit }) {
	const [decisionsList, setDecisionsList] = useState();

	useEffect(() => {
		const ls = localStorage.getItem("decisionsList");
		if (ls) {
			const tempDecisionsList = JSON.parse(ls);
			setDecisionsList(tempDecisionsList.filter((e) => parseInt(e.id) !== parseInt(id)));
		}
	}, [id]);
	

	return (
		<StyledDecisionFooter>
			{!edit && decisionsList && (
				<>
					<StyledPageHeader>
						<h4>More decisions</h4>
					</StyledPageHeader>
					<DecisionSlider decisionBody={true} data={decisionsList} clearSearchResults={false} />
				</>
			)}
		</StyledDecisionFooter>
	);
}

DecisionFooter.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	edit: PropTypes.bool,
};
